import { render, staticRenderFns } from "./AccountVatId.vue?vue&type=template&id=0d43cf65&scoped=true"
import script from "./AccountVatId.vue?vue&type=script&lang=js"
export * from "./AccountVatId.vue?vue&type=script&lang=js"
import style0 from "./AccountVatId.vue?vue&type=style&index=0&id=0d43cf65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d43cf65",
  null
  
)

export default component.exports